(() => {
  'use strict';

  function initBoostSearchHandlers({ wrapper, resultsWrapper, overlay, topPanel, closeButton }) {
    if (!wrapper || !resultsWrapper || !overlay || !topPanel || !closeButton) return;
    if (wrapper.dataset.isHandled === 'true') return;

    function bindSearchInput(input) {
      if (!input || input.dataset.isHandled === 'true') return;
      const form = input.closest('form');
      input.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter' && form) form.submit();
      });
      input.dataset.isHandled = 'true';
    }

    wrapper.dataset.isHandled = 'true';
    overlay.addEventListener('click', () => {
      closeButton.click();
    });
    resultsWrapper.dataset.isResultsWrapper = 'true';

    new MutationObserver(() => {
      const searchBox = topPanel.querySelector('.boost-pfs-search-box');
      if (searchBox) {
        searchBox.focus();
        bindSearchInput(searchBox);
      }
    }).observe(wrapper, { attributes: true });
    wrapper.classList.add('handler-inited');

    const suggestionRoot = resultsWrapper.querySelector('.boost-pfs-search-suggestion');
    if (suggestionRoot) {
      new MutationObserver(() => {
        const isEmpty = !suggestionRoot.querySelector(
          '.boost-pfs-search-suggestion-groups-pro, .boost-pfs-search-suggestion-mobile .boost-pfs-search-suggestion-scroll-groups-element-wrapper',
        );
        const hasNoResult = !suggestionRoot.querySelector('.boost-pfs-search-suggestion-no-result');
        const hasPageResults =
          (suggestionRoot.querySelectorAll(
            ".boost-pfs-search-suggestion-group[data-group='pages'] li",
          )?.length || 0) > 1;
        resultsWrapper.querySelectorAll(`img[src*='_200x.']`).forEach((img) => {
          img.src = img.src.replace('_200x.', '_600x.');
        });
        resultsWrapper.dataset.hasResults = String(hasNoResult);
        resultsWrapper.dataset.hasPageResults = String(hasPageResults);
        resultsWrapper.dataset.isEmpty = String(isEmpty);
      }).observe(suggestionRoot, { childList: true });
    }
  }

  const THEME = window.THEME_GLOBAL || { BREAKPOINT: { TABLET: 767 } };
  const header = document.querySelector('.section-header');
  if (!header) return;

  function isProductPage() {
    return document.body.classList.contains('template-product');
  }

  function forceCloseMobileCategorySheet() {
    document.body.classList.remove('mobile-menu-sheet-open', 'menu-is-active');
    document.querySelector('.header')?.classList.remove('menu-is-active');
    header
      .querySelectorAll('[data-purpose="nav-toggler"].menu-is-active')
      .forEach((btn) => {
        btn.classList.remove('menu-is-active');
        btn.setAttribute('aria-expanded', 'false');
      });
    const panel = document.querySelector('.menu_toggle .mobile_menu.section-header__list-box');
    if (panel) panel.setAttribute('aria-hidden', 'true');
    document.body.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow');
    clearMobileNavAriaHidden();
  }
  let flyoutOpenedAtPageTop = false;

  function getScrollTop() {
    return (
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  function isPageAtTop() {
    return getScrollTop() <= 2;
  }

  function setScrollAtTheTop(atTop) {
    document.documentElement.setAttribute(
      'data-scroll-at-the-top',
      atTop ? 'true' : 'false',
    );
  }

  function isDesktopHeaderViewport() {
    return THEME && THEME.BREAKPOINT
      ? window.innerWidth > THEME.BREAKPOINT.TABLET
      : window.innerWidth > 767;
  }

  function isMobileHeaderViewport() {
    return !isDesktopHeaderViewport();
  }

  function syncScrollAtTheTopFromPosition() {
    setScrollAtTheTop(isPageAtTop());
  }

  function restorePageTopStateAfterFlyoutClose() {
    const restoreTop = flyoutOpenedAtPageTop || isPageAtTop();
    flyoutOpenedAtPageTop = false;
    if (!restoreTop) {
      syncScrollAtTheTopFromPosition();
      return;
    }
    window.scrollTo(0, 0);
    setScrollAtTheTop(true);
  }

  function scheduleHeaderChromeBlurIfAtTop() {
    const blurIfNeeded = () => {
      if (document.documentElement.getAttribute('data-scroll-at-the-top') !== 'true') return;
      if (!document.body.classList.contains('template-index')) return;
      const ae = document.activeElement;
      const headerRoot = document.getElementById('shopify-section-header') || header;
      if (ae instanceof Element && headerRoot.contains(ae)) {
        ae.blur();
      }
    };
    setTimeout(blurIfNeeded, 0);
    setTimeout(blurIfNeeded, 50);
  }

  function dispatchLayoutSyncEvents() {
    window.dispatchEvent(new Event('scroll'));
    if (THEME?.EVENT?.updateGlobalCssVariables) {
      window.dispatchEvent(new CustomEvent(THEME.EVENT.updateGlobalCssVariables));
    }
  }

  const MOBILE_NAV_ARIA_FLAG = 'data-mobile-nav-aria-hidden';
  const MOBILE_NAV_ARIA_PREV = 'data-mobile-nav-aria-previous';

  function buildAriaKeepSet(keepRoot) {
    const keep = new Set();
    if (!(keepRoot instanceof Element)) return keep;

    for (let node = keepRoot; node; node = node.parentElement) {
      keep.add(node);
    }
    keepRoot.querySelectorAll('*').forEach((node) => keep.add(node));
    return keep;
  }

  function stashAndSetAriaHidden(el, hidden) {
    if (!(el instanceof Element)) return;
    if (!el.hasAttribute(MOBILE_NAV_ARIA_FLAG)) {
      el.setAttribute(MOBILE_NAV_ARIA_PREV, el.getAttribute('aria-hidden') ?? '');
      el.setAttribute(MOBILE_NAV_ARIA_FLAG, 'true');
    }
    el.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }

  function restoreMobileNavAriaHidden(el) {
    if (!(el instanceof Element) || !el.hasAttribute(MOBILE_NAV_ARIA_FLAG)) return;
    const prev = el.getAttribute(MOBILE_NAV_ARIA_PREV);
    if (prev === '') el.removeAttribute('aria-hidden');
    else el.setAttribute('aria-hidden', prev);
    el.removeAttribute(MOBILE_NAV_ARIA_FLAG);
    el.removeAttribute(MOBILE_NAV_ARIA_PREV);
  }

  function clearMobileNavAriaHidden() {
    document
      .querySelectorAll(`[${MOBILE_NAV_ARIA_FLAG}="true"]`)
      .forEach(restoreMobileNavAriaHidden);
  }

  /** VoiceOver / TalkBack: hide page chrome outside keepRoot (+ ancestors + descendants). */
  function applyAriaHiddenOutside(keepRoot, extraKeepRoots = []) {
    const keep = buildAriaKeepSet(keepRoot);
    extraKeepRoots.forEach((root) => {
      buildAriaKeepSet(root).forEach((node) => keep.add(node));
    });
    document.body.querySelectorAll('*').forEach((el) => {
      if (keep.has(el)) return;
      stashAndSetAriaHidden(el, true);
    });
  }

  function syncMobileMenuAriaHidden() {
    if (isProductPage()) {
      clearMobileNavAriaHidden();
      return;
    }

    if (!isMobileHeaderViewport()) {
      clearMobileNavAriaHidden();
      return;
    }

    const mobileMenu = document.querySelector('.mobile_menu.section-header__list-box');
    const mobileBtn = document
      .querySelector('.section-header__content.menu_toggle')
      ?.querySelector('.section-header__list-item-link[data-purpose="nav-toggler"]');
    const menuOpen = Boolean(mobileBtn?.classList.contains('menu-is-active'));

    clearMobileNavAriaHidden();

    if (!menuOpen || !mobileMenu) return;

    /* Bottom nav sheet: backdrop handles dimming — mass aria-hidden breaks scroll/focus/submenus */
    if (document.body.classList.contains('has-mobile-bottom-nav')) {
      return;
    }

    const openLi = mobileMenu.querySelector('.section-header__list-item.dropdown--active');
    const openPanel = openLi?.querySelector('.section-header__dropdown-content');

    if (openPanel) {
      applyAriaHiddenOutside(openPanel);
      return;
    }

    const l1ExtraKeep = mobileBtn?.classList.contains('menu-is-active') ? [mobileBtn] : [];
    applyAriaHiddenOutside(mobileMenu, l1ExtraKeep);
    mobileMenu.querySelectorAll('.section-header__dropdown-content').forEach((panel) => {
      const item = panel.closest('.section-header__list-item');
      if (item?.classList.contains('dropdown--active')) return;
      stashAndSetAriaHidden(panel, true);
    });
  }

  /** Blur from L2 header (close/back) often has relatedTarget null when the panel hides; do not treat as leaving the flyout. */
  function isSubmenuHeaderFocusBlur(ev) {
    const t = ev.target;
    return t instanceof Element && Boolean(t.closest('.section-header__dropdown-header'));
  }

  /** Bottom-nav category sheet is moved to `document.body`; keep it inside the open flyout. */
  function isInsideMobileCategorySheet(el) {
    if (!(el instanceof Element)) return false;
    const dockedSheet = document.querySelector('.mobile_menu--bottom-nav');
    if (dockedSheet?.contains(el)) return true;
    if (el.closest('.mobile-bottom-nav__shell, .mobile-sheet-backdrop, #mobile-sheet-backdrop')) return true;
    const mobileShell = document.querySelector('.section-header__content.menu_toggle');
    return Boolean(mobileShell?.contains(el));
  }

  function isBottomNavCategoryMode() {
    return document.body.classList.contains('has-mobile-bottom-nav');
  }

  /* ——— Boost search (header search icon) ——— */
  header
    .querySelectorAll("[data-name='search'] .section-header__list-item-link")
    .forEach((link) => {
      link.addEventListener('click', (ev) => {
        const input = document.querySelector('form.boost-pfs-search-form .boost-pfs-search-input');
        if (!input) return;
        ev.preventDefault();
        input.click();
        const tablet =
          THEME && THEME.BREAKPOINT
            ? window.innerWidth <= THEME.BREAKPOINT.TABLET
            : window.innerWidth <= 767;
        if (tablet) {
          const [w1, w2] = [
            ...(document.querySelectorAll('.boost-pfs-search-suggestion-wrapper') || []),
          ];
          initBoostSearchHandlers({
            wrapper: w1,
            resultsWrapper: w2,
            overlay: document.querySelector('.boost-pfs-search-suggestion-mobile-overlay'),
            topPanel: document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel'),
            closeButton: document.querySelector(
              '.boost-pfs-search-suggestion-mobile-top-panel .boost-pfs-search-btn-close-suggestion',
            ),
          });
        } else {
          const [w1, w2] = [
            ...(document.querySelectorAll('.boost-pfs-search-suggestion-wrapper') || []),
          ];
          initBoostSearchHandlers({
            wrapper: w1,
            resultsWrapper: w2,
            overlay: document.querySelector('.boost-pfs-search-suggestion-style3-overlay'),
            topPanel: document.querySelector('.boost-pfs-search-suggestion-style3-top-panel'),
            closeButton: document.querySelector(
              '.boost-pfs-search-suggestion-style3-top-panel .boost-pfs-search-btn-close-suggestion',
            ),
          });
        }
      });
    });

  function getMobileNavToggler() {
    return document.querySelector(
      '.section-header__content.menu_toggle [data-purpose="nav-toggler"]',
    );
  }

  function setNavFlyoutOpen(button, open) {
    if (isProductPage() && window.innerWidth <= 767 && open) return;

    const mobileToggler = button?.closest('.menu_toggle') ? getMobileNavToggler() : null;
    const flyoutButton = mobileToggler || button;

    document.body.classList.toggle('menu-is-active', open);
    flyoutButton.closest('.header')?.classList.toggle('menu-is-active', open);
    flyoutButton.classList.toggle('menu-is-active', open);
    flyoutButton.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (button?.closest('.menu_toggle')) {
      document.body.classList.toggle('mobile-menu-sheet-open', open);
    }

    const mobileMenuPanel = document.querySelector('.menu_toggle .mobile_menu.section-header__list-box');
    if (mobileMenuPanel) {
      mobileMenuPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    if (open) {
      flyoutOpenedAtPageTop = isPageAtTop();
      setScrollAtTheTop(false);
    }
    if (!open) {
      restorePageTopStateAfterFlyoutClose();
      const restoredTop = document.documentElement.getAttribute('data-scroll-at-the-top') === 'true';
      if (restoredTop) {
        requestAnimationFrame(() => dispatchLayoutSyncEvents());
      } else {
        dispatchLayoutSyncEvents();
      }
      scheduleHeaderChromeBlurIfAtTop();
      header
        .querySelectorAll(
          '.section-header__list.dropdown--active, .section-header__list-item.dropdown--active',
        )
        .forEach((el) => {
          el.classList.remove('dropdown--active');
        });
      header.querySelectorAll('.section-header__list-item-dropdown-toggler').forEach((b) => {
        b.setAttribute('aria-expanded', 'false');
      });
    }
    syncMobileMenuAriaHidden();
  }

  function openCustomerHub() {
    if (typeof window.customerHubApi?.open === 'function') {
      window.customerHubApi.open();
      return true;
    }
    if (window.location.hash === '#k-hub') {
      window.dispatchEvent(new HashChangeEvent('hashchange'));
      return false;
    }
    window.location.hash = 'k-hub';
    return false;
  }

  /* ——— Mobile sticky Account → K-Hub ——— */
  header
    .querySelectorAll('[data-list="sticky"] [data-name="account"] .section-header__list-item-link')
    .forEach((link) => {
      link.addEventListener('click', (ev) => {
        if (!isMobileHeaderViewport()) return;

        ev.preventDefault();

        const openBtn = header.querySelector(
          '.section-header__list-item-link[data-purpose="nav-toggler"].menu-is-active',
        );
        if (openBtn) setNavFlyoutOpen(openBtn, false);

        const fallbackUrl = link.getAttribute('data-account-fallback');
        const hubOpenedViaApi = openCustomerHub();

        if (!hubOpenedViaApi && fallbackUrl) {
          setTimeout(() => {
            if (!document.querySelector('.kl-hub-drawer')) {
              window.location.assign(fallbackUrl);
            }
          }, 500);
        }
      });
    });

  /* ——— Burger: mobile + desktop flyout ——— */
  header
    .querySelectorAll('.section-header__list-item-link[data-purpose="nav-toggler"]')
    .forEach((btn) => {
      btn.addEventListener('click', () => {
        const open = !btn.classList.contains('menu-is-active');
        setNavFlyoutOpen(btn, open);
      });
    });

  header.querySelectorAll('[data-mobile-menu-close]').forEach((btn) => {
    btn.addEventListener('click', (ev) => {
      ev.preventDefault();
      const toggler = getMobileNavToggler();
      if (toggler?.classList.contains('menu-is-active')) {
        setNavFlyoutOpen(toggler, false);
        toggler.focus();
        return;
      }
      forceCloseMobileCategorySheet();
      syncMobileMenuAriaHidden();
    });
  });

  document.querySelector('[data-mobile-pdp-back]')?.addEventListener('click', () => {
    const fallback = document.querySelector('[data-mobile-pdp-back]')?.dataset.fallbackHref;
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    if (document.referrer && new URL(document.referrer).origin === window.location.origin) {
      window.location.assign(document.referrer);
      return;
    }
    if (fallback) window.location.assign(fallback);
  });

  function syncSubmenuPanelAria(listItem) {
    const toggler = listItem.querySelector('.section-header__list-item-dropdown-toggler');
    const open = listItem.classList.contains('dropdown--active');
    if (toggler) toggler.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function setDropdownBranch(list, listItem, open) {
    if (open) {
      list.querySelectorAll('.section-header__list-item.dropdown--active').forEach((li) => {
        li.classList.remove('dropdown--active');
        syncSubmenuPanelAria(li);
      });
      list.classList.add('dropdown--active');
      listItem.classList.add('dropdown--active');
    } else {
      listItem.classList.remove('dropdown--active');
      if (!list.querySelector('.section-header__list-item.dropdown--active')) {
        list.classList.remove('dropdown--active');
      }
    }
    syncSubmenuPanelAria(listItem);
    syncMobileMenuAriaHidden();
  }

  /* ——— L2 submenu toggle ——— */
  header.querySelectorAll('.section-header__list-item-dropdown-toggler').forEach((toggler) => {
    toggler.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      const list = toggler.closest('.section-header__list');
      const listItem = toggler.closest('.section-header__list-item');
      if (!list || !listItem) return;
      const open = !listItem.classList.contains('dropdown--active');
      setDropdownBranch(list, listItem, open);
    });
  });

  /* ——— Mobile sheet: full row opens submenu (not just chevron) ——— */
  header.querySelectorAll(
    '.mobile-menu-sheet .section-header__list-item.half-list-item .section-header__list-item-link-box',
  ).forEach((box) => {
    box.addEventListener('click', (ev) => {
      const toggler = box.querySelector('.section-header__list-item-dropdown-toggler');
      if (!toggler) return;
      if (ev.target.closest('.section-header__list-item-dropdown-toggler')) return;
      ev.preventDefault();
      ev.stopPropagation();
      toggler.click();
    });
  });

  /* ——— Mobile submenu back ——— */
  header.querySelectorAll('.section-header__dropdown-header-button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const list = btn.closest('.section-header__list');
      const listItem = btn.closest('.section-header__list-item');
      list?.classList.remove('dropdown--active');
      listItem?.classList.remove('dropdown--active');
      if (listItem) syncSubmenuPanelAria(listItem);
      syncMobileMenuAriaHidden();
    });
  });

  /* ——— Accordion columns ——— */
  header.querySelectorAll('.section-header__dropdown-list-title-toggler').forEach((btn) => {
    btn.addEventListener('click', () => {
      const box = btn.closest('.section-header__dropdown-list-title-box');
      if (!box) return;
      box.classList.toggle('list-is-active');
      const expanded = box.classList.contains('list-is-active');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  });

  /* ——— Leaving L2 panel: close only when focus truly left the open row ——— */
  header.addEventListener(
    'focusout',
    (ev) => {
      if (isBottomNavCategoryMode()) return;
      const t = ev.target;
      const el = t && t.nodeType === Node.ELEMENT_NODE ? t : t.parentElement;
      const li = el?.closest('.section-header__list-item.dropdown--active');
      if (!li) return;
      const rt = ev.relatedTarget;

      /* Desktop only: Shift+Tab from L2 (e.g. close button) lands on L1 in the same li; li.contains(rt) would skip close. */
      if (isDesktopHeaderViewport()) {
        const panel = li.querySelector('.section-header__dropdown-content');
        if (
          panel &&
          t instanceof Node &&
          panel.contains(t) &&
          rt instanceof Element &&
          li.contains(rt) &&
          !panel.contains(rt)
        ) {
          li.classList.remove('dropdown--active');
          li.closest('.section-header__list')?.classList.remove('dropdown--active');
          syncSubmenuPanelAria(li);
          syncMobileMenuAriaHidden();
          return;
        }
      }

      if (rt && li.contains(rt)) return;
      if (rt == null) {
        setTimeout(() => {
          const ae = document.activeElement;
          if (!ae || li.contains(ae)) return;
          li.classList.remove('dropdown--active');
          li.closest('.section-header__list')?.classList.remove('dropdown--active');
          syncSubmenuPanelAria(li);
          syncMobileMenuAriaHidden();
        }, 0);
        return;
      }
      li.classList.remove('dropdown--active');
      li.closest('.section-header__list')?.classList.remove('dropdown--active');
      syncSubmenuPanelAria(li);
      syncMobileMenuAriaHidden();
    },
    true,
  );

  /**
   * Logo / icons live under `.desktop_toggle` / `.menu_toggle` but outside the nav column
   * (`.section_header_nav` or the first column that wraps `.mobile_menu`). `focusin` on the
   * full row therefore cannot detect “left menu for row chrome”. Close when focus leaves the
   * nav column only while the flyout is open. Safer than a single “last focusable” + Tab:
   * last tab order changes with open L2 / accordions and misses non-keyboard focus moves.
   */
  function closeFlyoutIfFocusLeftNavRegion(navRegion, flyoutBtn, ev) {
    if (!navRegion || !flyoutBtn?.classList.contains('menu-is-active')) return;
    if (!(ev.target instanceof Node) || !navRegion.contains(ev.target)) return;
    const rt = ev.relatedTarget;

    const finish = () => {
      if (!flyoutBtn.classList.contains('menu-is-active')) return;
      const ae = document.activeElement;
      if (ae && navRegion.contains(ae)) return;
      setNavFlyoutOpen(flyoutBtn, false);
    };

    if (rt && navRegion.contains(rt)) return;
    if (rt == null) {
      if (isSubmenuHeaderFocusBlur(ev)) return;
      setTimeout(finish, 0);
      return;
    }
    finish();
  }

  document
    .querySelector('.section-header__content-item.section_header_nav')
    ?.addEventListener('focusout', (ev) => {
      const shell = document.querySelector('.section-header__content.desktop_toggle');
      const btn = shell?.querySelector('.desktop_toggle.menu-is-active');
      closeFlyoutIfFocusLeftNavRegion(ev.currentTarget, btn, ev);
    });

  /**
   * Studio / “Back to” links sit in `section_header_nav` but outside `.desktop_menu`; leaving only
   * the flyout for those would not fire the nav-column handler above. Close when focus leaves the
   * menu panel, except when moving to the desktop burger (sibling of `.desktop_menu`).
   */
  function closeFlyoutIfFocusLeftDesktopMenuPanel(menuPanel, flyoutBtn, ev) {
    if (!menuPanel || !flyoutBtn?.classList.contains('menu-is-active')) return;
    if (!(ev.target instanceof Node) || !menuPanel.contains(ev.target)) return;
    const rt = ev.relatedTarget;
    if (rt && menuPanel.contains(rt)) return;
    if (rt === flyoutBtn || (flyoutBtn instanceof Element && flyoutBtn.contains(rt))) return;

    const finish = () => {
      if (!flyoutBtn.classList.contains('menu-is-active')) return;
      const ae = document.activeElement;
      if (ae && menuPanel.contains(ae)) return;
      if (ae === flyoutBtn || (flyoutBtn instanceof Element && flyoutBtn.contains(ae))) return;
      setNavFlyoutOpen(flyoutBtn, false);
    };

    if (rt == null) {
      if (isSubmenuHeaderFocusBlur(ev)) return;
      setTimeout(finish, 0);
      return;
    }
    finish();
  }

  document
    .querySelector('.desktop_menu.section-header__list-box')
    ?.addEventListener('focusout', (ev) => {
      const shell = document.querySelector('.section-header__content.desktop_toggle');
      const btn = shell?.querySelector('.desktop_toggle.menu-is-active');
      closeFlyoutIfFocusLeftDesktopMenuPanel(ev.currentTarget, btn, ev);
    });

  const mobileMenuPanel = document.querySelector('.mobile_menu.section-header__list-box');
  mobileMenuPanel?.addEventListener('focusout', (ev) => {
    if (isBottomNavCategoryMode()) return;
    const shell = document.querySelector('.section-header__content.menu_toggle');
    const btn = shell?.querySelector(
      '.section-header__list-item-link[data-purpose="nav-toggler"].menu-is-active',
    );
    closeFlyoutIfFocusLeftNavRegion(ev.currentTarget, btn, ev);
  });

  /* ——— Close flyout when focus leaves the whole header row (e.g. into page content) ——— */
  document.addEventListener(
    'focusin',
    (ev) => {
      const t = ev.target;
      if (!(t instanceof Element)) return;

      const desktopShell = document.querySelector('.section-header__content.desktop_toggle');
      const desktopBtn = desktopShell?.querySelector('.desktop_toggle.menu-is-active');
      if (desktopShell && desktopBtn?.classList.contains('menu-is-active')) {
        if (!desktopShell.contains(t)) {
          setNavFlyoutOpen(desktopBtn, false);
        }
      }

      const mobileShell = document.querySelector('.section-header__content.menu_toggle');
      const mobileBtn = mobileShell?.querySelector(
        '.section-header__list-item-link[data-purpose="nav-toggler"].menu-is-active',
      );
      if (mobileShell && mobileBtn?.classList.contains('menu-is-active')) {
        if (!isInsideMobileCategorySheet(t)) {
          setNavFlyoutOpen(mobileBtn, false);
        }
      }
    },
    true,
  );

  /* ——— Escape closes nested menu then flyout ——— */
  document.addEventListener('keydown', (ev) => {
    if (ev.key !== 'Escape') return;
    const active = document.activeElement;
    if (!active || !header.contains(active)) return;

    const openLi = header.querySelector('.section-header__list-item.dropdown--active');
    if (openLi) {
      openLi.classList.remove('dropdown--active');
      openLi.closest('.section-header__list')?.classList.remove('dropdown--active');
      syncSubmenuPanelAria(openLi);
      syncMobileMenuAriaHidden();
      openLi.querySelector('.section-header__list-item-dropdown-toggler')?.focus();
      ev.preventDefault();
      return;
    }

    const openBtn = header.querySelector(
      '.section-header__list-item-link[data-purpose="nav-toggler"].menu-is-active',
    );
    if (openBtn) {
      setNavFlyoutOpen(openBtn, false);
      if (document.documentElement.getAttribute('data-scroll-at-the-top') !== 'true') {
        openBtn.focus();
      }
      ev.preventDefault();
    }
  });

  let mobileAriaResizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(mobileAriaResizeTimer);
    mobileAriaResizeTimer = setTimeout(syncMobileMenuAriaHidden, 150);
  });

  /* Legacy inline handlers in older cached HTML */
  window.toggleElementClass = (el, className) => {
    if (el) el.classList.toggle(className);
  };

  if (isProductPage()) {
    forceCloseMobileCategorySheet();
    document.addEventListener('DOMContentLoaded', forceCloseMobileCategorySheet);
    window.addEventListener('pageshow', (ev) => {
      if (ev.persisted) forceCloseMobileCategorySheet();
    });
  }
})();
